
//Swiper 4 (5.0からはIE11がサポートされていない)
//import Swiper from 'swiper';
//import Swiper from 'swiper/bundle';

// Swiper 6.0
//import Swiper, { Navigation, Pagination } from 'swiper';


export class Swp {
    constructor(){
        this.swipers = [];

        this.swiperRecruit;
        this.swiperSP;
        this.isSwiperSp = false;
        this.breakPoint = 1000;
    }

    init(){
        //this.body = document.getElementsByTagName('body')[0];
        //this.html = document.getElementsByTagName('html')[0];
        

        if(document.getElementById('swiper-a')){
            this.swipers['a'] = new Swiper('#swiper-a', {
                autoplay: false,
                speed: 500,
                effect: 'slide',
                loop: true,
                //slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                on: {
                    init: function () {
                        //this.params.autoplay.delay=1000;
                        //this.autoplay.start();
                    }
                }
            });
    
        }

        if(document.getElementById('swiper-b')){
            this.swipers['b'] = new Swiper('#swiper-b', {
                autoplay: false,
                speed: 500,
                effect: 'slide',
                loop: true,
                //slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                on: {
                    init: function () {
                        //this.params.autoplay.delay=1000;
                        //this.autoplay.start();
                    }
                }
            });
            this.swipers['b-caption'] = new Swiper('#swiper-b-caption', {
                autoplay: false,
                speed: 500,
                effect: 'slide',
                loop: true,
                //slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                on: {
                    init: function () {
                        //this.params.autoplay.delay=1000;
                        //this.autoplay.start();
                    }
                }
            });

            this.swipers['b-caption'].allowTouchMove = false;
            this.swipers['b'].controller.control =  this.swipers['b-caption'];
        }

        if(document.getElementById('swiper-c')){
            this.swipers['c'] = new Swiper('#swiper-c', {
                autoplay: false,
                speed: 500,
                effect: 'slide',
                loop: true,
                //slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                on: {
                    init: function () {
                        //this.params.autoplay.delay=1000;
                        //this.autoplay.start();
                    }
                }
            });
            this.swipers['c-caption'] = new Swiper('#swiper-c-caption', {
                autoplay: false,
                speed: 500,
                effect: 'slide',
                loop: true,
                //slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                on: {
                    init: function () {
                        //this.params.autoplay.delay=1000;
                        //this.autoplay.start();
                    }
                }
            });
            this.swipers['c-caption'].allowTouchMove = false;
            this.swipers['c'].controller.control =  this.swipers['c-caption'];
        }

        

        this.swiperRecruit = new Swiper('.recruit-container .js-swiper', {
            speed: 500,
            effect: 'slide',
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
            },
        });


        this.onResize();
    }


    onResize(){
        if(document.querySelectorAll('.js-swiper-only-sp')){
            //console.log(this.swiperSP);
            if( this.breakPoint < window.innerWidth){
                //PCではSwiperにしない
                if(this.isSwiperSp){
                    [].forEach.call(this.swiperSP, (swp) => {
                        swp.destroy(false,true);
                    });
                    this.isSwiperSp = false;
                }
            }else{
                if(!this.isSwiperSp){
                    this.isSwiperSp = true;
                    this.swiperSP = new Swiper('.js-swiper-only-sp', {
                        speed: 500,
                        effect: 'slide',
                        spaceBetween: 20,
                        loop: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                }
            }
        }
        
    }


}